export default {
  name: 'card',
  components: {},
  props: {
    to: Object,
    badge: String,
    big: Boolean,
    isChecked: Boolean,
    checkable: Boolean
  },
  data () {
    return {
      showExtra: false
    }
  },
  computed: {
  },
  activated () {
    this.showExtra = false
  },
  methods: {
    openExtra () {
      if (this.to) return
      if (!this.$slots['extra']) return
      this.showExtra = !this.showExtra
      if (this.showExtra) this.$emit('onOpen')
    },
    clickCheck (e) {
      e.stopPropagation()
      this.$emit('check')
    }
  }
}
